import * as React from 'react'

const Checkbox = ({
  checked,
  disabled,
  onChange,
  id,
  type = 'default',
  onMouseDown,
}: {
  onChange: (checked: boolean) => void
  checked: boolean
  disabled?: boolean
  id?: string
  type?: 'dot' | 'default'
  onMouseDown?: (e: React.MouseEvent) => void
}) => {
  return (
    <input
      id={id}
      disabled={disabled}
      type="checkbox"
      onClick={(e) => e.stopPropagation()}
      checked={checked}
      onMouseDown={(e) => {
        onMouseDown?.(e)
        e.stopPropagation()
      }}
      onChange={(e) => onChange(e.target.checked)}
      className={`focus:outline-none tw-relative tw-h-4 tw-w-4 tw-appearance-none tw-rounded-[4px] tw-border tw-border-solid tw-border-neutral checked:!tw-border-primary checked:!tw-bg-primary focus:!tw-border-primary active:!tw-border-primary ${disabled ? 'tw-border-neutral/30 tw-bg-base-300' : 'tw-cursor-pointer'} ${type === 'dot' ? 'tableCheckboxDot' : 'tableCheckboxDefault'}`}
    />
  )
}

export default Checkbox
